import * as ngCore from '@angular/core'
import * as ec from '@attain-apps/fe/web/main/lib/entity-collection'

import * as routeBound from '../../../route-bound'
import * as clusters from '../clusters'
import * as occupants from '../occupants'
import * as recordAssignedOrgs from '../record-assigned-orgs'
import * as records from '../records'
import * as responsiblePersons from '../responsible-persons'

import { Api } from './api.service'
import associations from './associations'
import * as effects from './effects'
import * as plugins from './plugins'
import type { TypeParams } from './types'

/**
 * Employees collection for fetching space employees
 */
@ngCore.Injectable()
export class Collection extends ec.Collection<TypeParams, typeof associations> {
  constructor() {
    super({
      api: ngCore.inject(Api),
      associations,
      context$: ngCore.inject(routeBound.scenario.Context.TOKEN),
      identify: employee => employee.id,
      name: ec.Name.Predefined.SpaceEmployee,
      plugins: {
        additionalFactories: [new plugins.duplicateDetection.Factory()],
        currentList: {
          creationStrategy: 'pessimistic',
        },
      },
    })

    const clustersEc = ngCore.inject(clusters.Collection)

    const recordOccupantsEc = ngCore.inject(
      occupants.recordOccupants.Collection,
    )
    const recordResponsiblePersonsEc = ngCore.inject(
      responsiblePersons.recordResponsiblePersons.Collection,
    )
    const clusterResponsiblePersonsEc = ngCore.inject(
      responsiblePersons.clusterResponsiblePersons.Collection,
    )
    const recordAssignedOrgsEc = ngCore.inject(recordAssignedOrgs.Collection)
    const recordsEc = ngCore.inject(records.Collection)
    const clusterOccupantsEc = ngCore.inject(
      occupants.clusterOccupants.Collection,
    )
    this.feature.registerEffects(
      effects.autoSelectOnCreateForOccupants(
        this,
        recordOccupantsEc,
        clusterOccupantsEc,
      ),
      effects.autoSelectOnCreateForResponsiblePersons(
        this,
        recordResponsiblePersonsEc,
        clusterResponsiblePersonsEc,
      ),
      effects.autoSelectOnCreateForBulkResponsiblePersons(this, recordsEc),
      effects.setRecordDepartmentFilterOnBulkSessionStart(this, recordsEc),
      effects.setRecordDepartmentFilterOnSessionStart(
        this,
        recordOccupantsEc,
        recordResponsiblePersonsEc,
        recordAssignedOrgsEc,
      ),
      effects.setClusterDepartmentFilterOnSessionStart(
        this,
        clusterOccupantsEc,
        clusterResponsiblePersonsEc,
        clustersEc,
      ),
      effects.clearFiltersOnClose(
        this,
        recordOccupantsEc,
        clusterOccupantsEc,
        recordResponsiblePersonsEc,
        clusterResponsiblePersonsEc,
      ),
    )
  }
}
